import React from 'react'
import { string, bool, shape, object } from 'prop-types'
import styled, { withTheme } from 'styled-components'
import { Box } from 'rebass'
import ContentSectionHeader from '../../components/ContentSectionHeader'
import LinkRounded from '../../components/LinkRounded'

const Hero = styled(({ theme, connect, background, ...rest }) => (
  <Box {...rest} />
))`
  position: relative;
  z-index: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${(props) => props.background.x1});
  background-color: ${(props) =>
    props.background.color || props.theme.colors.blue};
  ${(props) => (props.connect ? 'margin-bottom: -33px;' : '')};
  ${(props) => (props.connect ? 'padding-bottom: 115px;' : '')};

  @media only screen and (-webkit-min-device-pixel-ratio: 1.3),
    only screen and (min-resolution: 144dpi),
    only screen and (min-resolution: 1.5dppx) : {
    background-image: url('${(props) => props.background.x2}');
  }
`
const CtaButton = styled(LinkRounded)`
  margin-right: 0 !important;
`

const ContentSectionHero = (props) => {
  return (
    <Hero
      pt={'4vh'}
      pb={'10vh'}
      background={props.bg}
      connect={props.connect}
      className={props.className}
      {...props.wrapperProps}
    >
      <ContentSectionHeader
        heading={props.heading}
        title={props.title}
        reversed={props.reversed}
        fg={props.fg || props.theme.colors.grey}
        ext={props.ext}
        alignment={props.alignment}
        relaxed={props.relaxed}
      >
        {props.children}
        {(props.ctaPath || props.ctaHref) && props.ctaLabel && (
          <CtaButton
            thin
            reversed
            shadow
            to={props.ctaPath}
            href={props.ctaHref}
          >
            {props.ctaLabel}
          </CtaButton>
        )}
      </ContentSectionHeader>
    </Hero>
  )
}

ContentSectionHero.defaultProps = {
  heading: '',
  title: 'no title',
  fg: '',
  bg: { x1: '', x2: '', color: '' },
  reversed: false,
  relaxed: false,
  alignment: 'center',
  connect: false,
  ctaPath: '',
  ctaLabel: ''
}
ContentSectionHero.propTypes = {
  heading: string,
  title: string,
  fg: string,
  bg: shape({ x1: string, x2: string, color: string }),
  reversed: bool,
  alignment: string,
  relaxed: bool,
  connect: bool,
  ctaPath: string,
  ctaLabel: string,
  className: string,
  wrapperProps: object
}
const Themed = withTheme(ContentSectionHero)
Themed.displayName = 'ContentSectionHero'
export default Themed
